export function storeCurrentUserId(currentUserId) {
  window.currentUserId = currentUserId;
}

export function retrieveCurrentUserId() {
  return window.currentUserId;
}
